import { Test } from '../lab-test/test.model';
import { TestAnalyte } from '../lab-test/test-analyte.model';
import { TestInput } from '../lab-test/test-input.model';
import { OnBoardingInput, OnBoardingOutput } from './onboarding-input.model';
import { InputData } from '../lab-test/input-data.model';
import { InputDataAllowable } from '../lab-test/input-data-allowable.model';
import { InputDataHelper } from './input-data-helper';
import * as _ from 'lodash';
import { TestInstrument } from '../lab-test/test-instrument.model';

export class OnBoardingAnalyte {
    labInstrumentId: number;
    studyTestId: number;
    studyTestDataId?: number;
    analyte: TestAnalyte;
    instrument: TestInstrument;

    inputData: OnBoardingInput;
    originalInputData: OnBoardingInput;

    outputData: OnBoardingOutput;
    originalOutputData: OnBoardingOutput;

    isSelected: boolean;
    isChecked: boolean;
}

export class OnBoardingAnalyteExtensions {
    static isCompleted(an: OnBoardingAnalyte): boolean {
        if (!an.originalInputData || !an.originalInputData.input || !an.originalInputData.allowableInput) {
            return false;
        }

        if (InputDataHelper.hasAllPropertiesValue(an.originalInputData)) {
            return true;
        }
        return false;
    }

    static isDirty(an: OnBoardingAnalyte): boolean {
        return OnBoardingAnalyteExtensions.isInputDataDirty(an.inputData, an.originalInputData);
    }

    static isChecked(an: OnBoardingAnalyte): boolean {
        if (an.isChecked === undefined) {
            return false;
        }
        return an.isChecked;
    }

    static isInputDataDirty(data: OnBoardingInput, originalData: OnBoardingInput): boolean {
        // We should exclude tea fields in field comparison to find out if input data are dirty
        const obj = {
            ...data,
            input: {
                ...data.input,
                teaDesc: '',
                teaGrammar: '',
                teaSchema: '',
            }
        } as OnBoardingInput;
        const objOriginal = {
            ...originalData,
            input: {
                ...originalData.input,
                teaDesc: '',
                teaGrammar: '',
                teaSchema: '',
            }
        } as OnBoardingInput;

        return !_.isEqual(obj, objOriginal);
    }

    static hasUnityData(an: OnBoardingAnalyte): boolean {
        return an.originalInputData.levelData && an.originalInputData.levelData.length > 1;
    }
}





// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/contracts/onboarding/onboarding-analyte.model.ts